export default "__VITE_ASSET__g_3Giram__"